import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { UserPredictionsListService } from './user-predictions-list.service';
import { NotificationService } from '../../../../../common/services';
import { UserPredictionModel } from '../models/user-prediction.model';
import { UserPredictionsListInitialState, UserPredictionsListLoad } from './user-predictions-list.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface UserPredictionsListStateModel {
  items: UserPredictionModel[];
}

const initialState: UserPredictionsListStateModel = {
  items: [],
};

@State<UserPredictionsListStateModel>({
  name: 'userPredictionsList',
  defaults: initialState,
})
@Injectable()
export class UserPredictionsListState {
  constructor(
    private userPredictionsListService: UserPredictionsListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: UserPredictionsListStateModel): UserPredictionsListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: UserPredictionsListStateModel): UserPredictionModel[] {
    return state.items;
  }

  @Action(UserPredictionsListLoad)
  getDataProtectionNoticeList(
    ctx: StateContext<UserPredictionsListStateModel>,
    { payload }: UserPredictionsListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.userPredictionsListService.getUserPredictionsList(payload).pipe(
      map((items: UserPredictionModel[]) => {
        ctx.patchState({ items });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(UserPredictionsListInitialState)
  setInitialState(ctx: StateContext<UserPredictionsListStateModel>): void {
    ctx.setState(initialState);
  }
}
